module.exports = __webpack_public_path__ + "static/media/access.9cea0753.wav";